import { gql } from '@apollo/client';

export interface PermissionResponse {
  permission: string;
  dependsOn: string[];
}

export interface PermissionCategoryResponse {
  id: string;
  name: string;
  permissions: PermissionResponse[];
}

export interface PermissionsCategoryResponseData {
  permissionCategories: PermissionCategoryResponse[];
}

export const GET_PERMISSIONS_CATEGORIES = gql`
  query permissionCategories {
    permissionCategories {
      id
      name
      permissions {
        permission
        dependsOn
      }
    }
  }
`;
